import styled, { css } from 'styled-components'

import { Card as DefaultCard } from '@/components/ui/card'
import { Icon } from '@/components/ui/icon'

export const CaretIcon = styled(Icon)<{ $isOpen: boolean }>(
  ({ theme, $isOpen }) => css`
    transform: ${$isOpen ? 'rotate(0deg)' : 'rotate(180deg)'};
    transition: transform ${theme.transition.duration.sm} ease;
  `,
)

export const TaskDetailsCard = styled(DefaultCard)`
  display: grid;
  grid-auto-flow: column;
  gap: ${({ theme }) => theme.space['20']};
  /* Note: 3.4rem (info row) + 4rem padding-y */
  height: 7.4rem;
  flex-shrink: 0;
`

export const FormLabel = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.space['4']};
`

export const FormLabelIconContainer = styled.div`
  background: ${({ theme }) => theme.colors.blue100};
  padding: ${({ theme }) => theme.space['4']};
  border-radius: ${({ theme }) => theme.border.radius['full']};
`

export const EmptyStateContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`
